module.exports = __webpack_public_path__ + "img/FSC_Logo_artemis.e7d8e7ed.svg";